/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Arialabel1Inputs */

const id_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorotan etalase profil`)
};

const ms_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorotan pameran profil`)
};

const da_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil showcase højdepunkter`)
};

const de_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil-Vitrine-Highlights`)
};

const en_us2_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile showcase highlights`)
};

const es_es2_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacados de la vitrina del perfil`)
};

const es_mx2_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacados de la vitrina del perfil`)
};

const fil_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga highlight ng showcase ng profile`)
};

const fr_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points forts de la vitrine du profil`)
};

const it_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punti salienti della vetrina del profilo`)
};

const hu_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil kirakat kiemelései`)
};

const nl_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel vitrine hoogtepunten`)
};

const no_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilens utstillingshøydepunkter`)
};

const pl_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najważniejsze elementy profilu`)
};

const pt_br2_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaques da vitrine do perfil`)
};

const pt_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destaques da vitrine do perfil`)
};

const ro_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidențieri vitrină profil`)
};

const fi_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiilin esittelykohokohdat`)
};

const sv_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilens skyltfönster-höjdpunkter`)
};

const vi_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm nổi bật của hồ sơ`)
};

const tr_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil vitrin öne çıkanları`)
};

const cs_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší položky profilové vitríny`)
};

const bg_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акценти от витрината на профила`)
};

const ru_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основные моменты из профиля`)
};

const uk_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основні досягнення профілю`)
};

const ar_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أبرز ما في الملف الشخصي`)
};

const hi_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल शोकेस हाइलाइट्स`)
};

const th_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฮไลต์โชว์เคสโปรไฟล์`)
};

const ja_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールショーケースハイライト`)
};

const zh_cn2_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个人资料展示柜`)
};

const zh_hant1_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`個人資料展示櫃`)
};

const ko_profile_showcase_arialabel1 = /** @type {(inputs: Profile_Showcase_Arialabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필 쇼케이스 하이라이트`)
};

/**
* | output |
* | --- |
* | "Profile showcase highlights" |
*
* @param {Profile_Showcase_Arialabel1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_arialabel1 = /** @type {((inputs?: Profile_Showcase_Arialabel1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Arialabel1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_arialabel1(inputs)
	if (locale === "ms") return ms_profile_showcase_arialabel1(inputs)
	if (locale === "da") return da_profile_showcase_arialabel1(inputs)
	if (locale === "de") return de_profile_showcase_arialabel1(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_arialabel1(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_arialabel1(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_arialabel1(inputs)
	if (locale === "fil") return fil_profile_showcase_arialabel1(inputs)
	if (locale === "fr") return fr_profile_showcase_arialabel1(inputs)
	if (locale === "it") return it_profile_showcase_arialabel1(inputs)
	if (locale === "hu") return hu_profile_showcase_arialabel1(inputs)
	if (locale === "nl") return nl_profile_showcase_arialabel1(inputs)
	if (locale === "no") return no_profile_showcase_arialabel1(inputs)
	if (locale === "pl") return pl_profile_showcase_arialabel1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_arialabel1(inputs)
	if (locale === "pt") return pt_profile_showcase_arialabel1(inputs)
	if (locale === "ro") return ro_profile_showcase_arialabel1(inputs)
	if (locale === "fi") return fi_profile_showcase_arialabel1(inputs)
	if (locale === "sv") return sv_profile_showcase_arialabel1(inputs)
	if (locale === "vi") return vi_profile_showcase_arialabel1(inputs)
	if (locale === "tr") return tr_profile_showcase_arialabel1(inputs)
	if (locale === "cs") return cs_profile_showcase_arialabel1(inputs)
	if (locale === "bg") return bg_profile_showcase_arialabel1(inputs)
	if (locale === "ru") return ru_profile_showcase_arialabel1(inputs)
	if (locale === "uk") return uk_profile_showcase_arialabel1(inputs)
	if (locale === "ar") return ar_profile_showcase_arialabel1(inputs)
	if (locale === "hi") return hi_profile_showcase_arialabel1(inputs)
	if (locale === "th") return th_profile_showcase_arialabel1(inputs)
	if (locale === "ja") return ja_profile_showcase_arialabel1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_arialabel1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_arialabel1(inputs)
	return ko_profile_showcase_arialabel1(inputs)
});
export { profile_showcase_arialabel1 as "profile.showcase.ariaLabel" }